import { ReportsActionTypes } from './types';
import { all, takeLatest, call, put, delay } from 'redux-saga/effects';
import Services from '../../services';

import {
  fetchReportsFailure,
  setReportTokenSuccess,
  setReportTokenFailure,
  setReportTypesSuccess,
  setReportTypesFailure,
  fetchReportFiltesSuccess,
  fetchReportFiltersFailure
} from './actions';
import { fetchAppFailure, fetchAppSuccess } from 'redux/app/actions';

export function* handleSetReportTokenAndTypes(request: any) {
  try {
    const response = yield call(Services.reports.getJRSToken);
    if (response) {
      const { token } = response;
      yield put(setReportTokenSuccess(token));
      const listResponse = yield call(Services.reports.fetchReportListService);
      !listResponse.error
        ? yield put(setReportTypesSuccess(listResponse))
        : yield put(setReportTypesFailure(listResponse.error));
      yield delay(300);
      window?.visualize?.config({
        auth: {
          preAuth: true,
          tokenName: 'pp',
          token,
          timezone: request.payload || 'Australia/Sydney',
          loginFn: function (properties: any, request: any) {
            return request({
              url: `${properties.url}?userTimezone=${properties.timezone}`,
              type: 'get',
              headers: { pp: properties.token }
            });
          }
        }
      });
      //   yield put(fetchReportsSuccess('SUCCESS'));
      yield put(fetchAppSuccess());
    } else {
      yield put(setReportTokenFailure('Reporting token expired.'));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchReportsFailure(errorMsg));
    yield put(fetchAppFailure(errorMsg));
  }
}

export function* handleFetchReportFiltesRequest(request: any) {
  try {
    /*
     * fetchReportInputControls
     *       params:
     *         token, and reportUrl
     */
    //const reportUrl = '/Reports/DBYD_States/DBYD_Admin_Dummy';
    if (request?.payload) {
      const inputControls = yield call(
        Services.reports.fetchReportInputControls,
        request.payload
      );
      inputControls && !inputControls.error
        ? yield put(fetchReportFiltesSuccess(inputControls))
        : yield put(fetchReportFiltersFailure(inputControls.error));
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchReportsFailure(errorMsg));
    yield put(fetchAppFailure(errorMsg));
  }
}

export function* watchFetchReportFiltesRequest() {
  yield takeLatest(
    ReportsActionTypes.FETCH_REPORT_FILTERS_REQUEST,
    handleFetchReportFiltesRequest
  );
}

export function* watchSetReportTokenAndTypes() {
  yield takeLatest(
    ReportsActionTypes.SET_REPORT_TOKEN_TYPES,
    handleSetReportTokenAndTypes
  );
}

export function* reportsSagas() {
  yield all([
    call(watchSetReportTokenAndTypes),
    call(watchFetchReportFiltesRequest)
  ]);
}

export default reportsSagas;
